import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const triggerLandedCostComparison = {
  name: "triggerLandedCostComparison" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    success: z.boolean(),
    workflowId: z.string().nullable(),
    error: z.string().nullable(),
  }),
};
